<template>
    <b-card header="Power of Attorney"
            header-bg-variant="info"
            header-text-variant="white"
    >
        <form @submit.prevent="submitForm()" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="6">
                    <b-form-group label="First Name">
                        <b-form-input id="poa_first_name"
                                      v-model="form.poa_first_name"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Last Name">
                        <b-form-input id="poa_last_name"
                                      v-model="form.poa_last_name"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Phone">
                        <b-form-input id="poa_phone"
                                      v-model="form.poa_phone"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Mobile Phone">
                        <b-form-input id="poa_mobile"
                                      v-model="form.poa_mobile"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12">
                    <hr />
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Address Line 1" label-for="address1">
                        <b-form-input
                                name="address1"
                                type="text"
                                v-model="form.address.address1"
                        >
                        </b-form-input>
                        <input-help :form="form" field="address.address1" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Address Line 2" label-for="address2">
                        <b-form-input
                                name="address2"
                                type="text"
                                v-model="form.address.address2"
                        >
                        </b-form-input>
                        <input-help :form="form" field="address.address2" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="City" label-for="poa_city">
                        <b-form-input
                                id="poa_city"
                                name="city"
                                type="text"
                                v-model="form.address.city"
                        >
                        </b-form-input>
                        <input-help :form="form" field="address.city" text=""></input-help>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Country" label-for="country">
                        <b-form-select name="country" :options="countries.getOptions()" v-model="form.address.country" />
                        <input-help :form="form" field="address.country" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="state" v-if="form.address.country === 'US'">
                        <b-form-select name="state" :options="states.getOptions()" v-model="form.address.state" />
                        <input-help :form="form" field="address.state" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="state" v-else>
                        <b-form-input
                                name="state"
                                type="text"
                                v-model="form.address.state"
                        >
                        </b-form-input>
                        <input-help :form="form" field="address.state" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Zip Code" label-for="zip">
                        <b-form-input
                                name="zip"
                                type="text"
                                v-model="form.address.zip"
                        >
                        </b-form-input>
                        <input-help :form="form" field="address.zip" text=""></input-help>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-btn variant="success" type="submit" size="lg">{{ create ? 'Continue' : 'Save' }}</b-btn>
                </b-col>
            </b-row>
        </form>
    </b-card>
</template>

<script>
    import States from '../../../classes/States';

    export default {
        name: "ClientPowerOfAttorney",

        props: {
            client: Object,
            create: Boolean,
        },

        data() {
            return {
                countries: new Countries(),
                states: new States(),
                form: new Form({
                    poa_first_name: this.client.poa_first_name,
                    poa_last_name: this.client.poa_last_name,
                    poa_phone: this.client.poa_phone,
                    poa_mobile: this.client.poa_mobile,
                    address: {
                        'country': 'US',
                    },
                }),
            }
        },

        mounted() {
            this.loadPoaAddress();
        },

        methods: {
            submitForm() {
                this.form.post('/business/clients/' + this.client.id + '/poa')
                    .then(response => {
                        if (this.create) {
                            this.$emit('continue');
                        }
                    });
            },

            loadPoaAddress() {
                let address = this.client.poa_address;
                if (address) {
                    this.form.address = address;
                }
            }
        }
    }
</script>

<style scoped>

</style>